import { createApi, createEffect, createStore } from "effector";
import { persist } from "effector-storage/session";

import { Appointment } from "@hunkware/shared/types";

import { AppointmentStore, AppointmentStoreState } from "./types";
import { defaultState } from "./utils";
import {
  appointmentCreate,
  couponCheck,
  createAddress,
} from "../../shared/api";

export const appointmentCreateFx = createEffect(appointmentCreate);
export const $appointment = createStore<AppointmentStore>(defaultState)
  .on(appointmentCreateFx.done, (state, response) => ({
    ...state,
    appointment: response.result.data.appointments[0],
  }))
  .on(appointmentCreateFx.pending, (state, loading) => ({ ...state, loading }));

persist<AppointmentStore>({
  store: $appointment,
  key: "booking-v4-appointment",
  def: defaultState,
});

export const createAddressFx = createEffect(createAddress);
$appointment.on(createAddressFx.done, (store, response) => ({
  ...store,
  appointment: {
    ...store.appointment,
    origin: response.result.data.addresses[0],
  },
}));

export const couponCheckFx = createEffect(couponCheck);
$appointment.on(couponCheckFx.done, (store, response) => ({
  ...store,
  appointment: {
    ...store.appointment,
    coupon: response.result.data.coupons[0],
  },
}));

export const appointmentApi = createApi($appointment, {
  set: (
    prevState: AppointmentStore,
    appointment: AppointmentStoreState,
  ): AppointmentStore => {
    return {
      ...prevState,
      appointment: {
        ...prevState.appointment,
        ...appointment,
      },
    };
  },

  resetKeys: (
    prevState: AppointmentStore,
    keys: (keyof Appointment)[],
  ): AppointmentStore => {
    const newAppointment = { ...prevState.appointment };

    keys.forEach((key) => {
      newAppointment[key] = undefined as never;
    });

    return {
      ...prevState,
      appointment: newAppointment,
    };
  },

  reset: (prevState: AppointmentStore) => ({
    ...defaultState,
    appointment: {
      ...defaultState?.appointment,
      coupon: prevState?.appointment?.coupon,
    },
  }),
});
